import { render, staticRenderFns } from "./CustomDotBadge.vue?vue&type=template&id=3a32b70c"
import script from "./CustomDotBadge.vue?vue&type=script&lang=ts"
export * from "./CustomDotBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports